/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Edit_Contract_DescriptionInputs */



/**
* | output |
* | --- |
* | "Only possible before the term is approved and before it starts. Once approved or started, the terms are fixed." |
*
* @param {Partner_Edit_Contract_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_edit_contract_description = /** @type {((inputs?: Partner_Edit_Contract_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Edit_Contract_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur möglich, solange der Vertrag nicht genehmigt ist und die Laufzeit nicht begonnen hat. Danach sind die Konditionen fest.")
	return /** @type {LocalizedString} */ ("Only possible before the term is approved and before it starts. Once approved or started, the terms are fixed.")
});